// Toggles for panels/overlays/zoom
export const TOGGLE_CONTENTS = 'TOGGLE_CONTENTS'
export const TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES'
export const TOGGLE_GUIDE = 'TOGGLE_GUIDE'
export const TOGGLE_EDITIONS = 'TOGGLE_EDITIONS'
export const TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE'

export const TOGGLE_ZOOM = 'TOGGLE_ZOOM'
export const UPDATE_ZOOM = 'UPDATE_ZOOM'
export const SLIDE_ZOOM = 'SLIDE_ZOOM'

export const TOGGLE_SEARCH = 'TOGGLE_SEARCH'
export const TOGGLE_SUBSCRIBE = 'TOGGLE_SUBSCRIBE'
export const TOGGLE_READER = 'TOGGLE_READER'
export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN'
export const UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN'

export const RESET_SECTION_INDICES = 'RESET_SECTION_INDICES'
export const CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX'
export const UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE'
export const UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE'
export const UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL'
export const UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL'
export const UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE'
export const UPDATE_GALLERY = 'UPDATE_GALLERY'
export const UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX'
export const UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js